import { ApiContext } from '../../types'
import getCurrentBearerToken from '../authentication/getCurrentBearerToken'

export default async function getProductShortDes(
  { client, config }: ApiContext,
  skus,
): Promise<any> {
  const bearerToken = await getCurrentBearerToken({ client, config })

  const response = await client.tools.genProductShortDes(
    { bearerToken },
    { skus },
  )
  if (response.isSuccess()) {
    return response.success()
  } else {
    return null
  }
}
